import React from 'react';
import {
  Box,
  HStack,
  Text,
  Button,
  useBreakpointValue,
} from '@chakra-ui/react';
import { ShieldAlert, ChevronRight } from 'lucide-react';
import { WarningSeverity } from '../../../../config/weatherWarnings';
import { hasUrgentWarnings } from '../../../../util/WeatherWarnings';

export default function WeatherWarningsBanner({
  warningsAnalysis,
  onViewDetails,
}) {
  const isMobile = useBreakpointValue({ base: true, md: false });

  if (!warningsAnalysis || !warningsAnalysis.hasWarnings) {
    return null;
  }

  const { warnings, highestSeverity } = warningsAnalysis;
  const isUrgent = hasUrgentWarnings(warningsAnalysis);

  const getBannerBg = () => {
    switch (highestSeverity) {
      case WarningSeverity.EXTREME:
        return 'linear-gradient(90deg, #c53030 0%, #e53e3e 50%, #c53030 100%)';
      case WarningSeverity.DANGER:
        return 'linear-gradient(90deg, #c05621 0%, #dd6b20 50%, #c05621 100%)';
      case WarningSeverity.WARNING:
        return 'linear-gradient(90deg, #b7791f 0%, #d69e2e 50%, #b7791f 100%)';
      default:
        return 'linear-gradient(90deg, #2b6cb0 0%, #3182ce 50%, #2b6cb0 100%)';
    }
  };

  const getAlertText = () => {
    const count = warnings.length;
    if (isUrgent) {
      return `${count} alerta${count > 1 ? 's' : ''} importante${count > 1 ? 's' : ''} en tu ruta`;
    }
    return `${count} alerta${count > 1 ? 's' : ''} meteorológica${count > 1 ? 's' : ''}`;
  };

  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      zIndex={10}
      bg={getBannerBg()}
      color="white"
      py={2}
      px={4}
      boxShadow="md"
      cursor="pointer"
      onClick={onViewDetails}
      _hover={{
        opacity: 0.95,
      }}
      transition="opacity 0.2s"
    >
      <HStack
        justify="space-between"
        align="center"
        maxW="container.xl"
        mx="auto"
      >
        <HStack spacing={2} flex={1}>
          <ShieldAlert
            size={20}
            style={isUrgent ? { animation: 'pulse 1.5s infinite' } : undefined}
          />
          <Text fontWeight="semibold" fontSize={isMobile ? 'sm' : 'md'}>
            {getAlertText()}
          </Text>
        </HStack>

        <Button
          size="sm"
          variant="ghost"
          color="white"
          rightIcon={<ChevronRight size={14} />}
          _hover={{ bg: 'whiteAlpha.200' }}
          onClick={onViewDetails}
        >
          {isMobile ? 'Ver' : 'Ver detalles'}
        </Button>
      </HStack>

      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}
      </style>
    </Box>
  );
}
